import { render, staticRenderFns } from "./ProductPreviewImage.vue?vue&type=template&id=a79f1890&"
import script from "./ProductPreviewImage.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports